import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sort',
    standalone: false
})
export class SortPipe  implements PipeTransform {
    constructor() {}
    transform<T>(array: T[], field: string): T[] {
        if (!Array.isArray(array)) {
            return [];
        }

        array.sort((a: T, b: T) => {
            if (a[field] < b[field]) {
                return -1;
            } else if (a[field] > b[field]) {
                return 1;
            } else {
                return 0;
            }
        });

        return array;
    }
}
